import { DocumentCard } from "../components/document-card";
import type { DocumentAction, UserDocument } from "../types/document";

type CoverLetterCardProps = {
  coverLetter: UserDocument;
  onOpen: (coverLetter: UserDocument) => void;
  onAction: (coverLetter: UserDocument, action: DocumentAction) => void;
};

export const CoverLetterCard = ({ coverLetter, onOpen, onAction }: CoverLetterCardProps) => {
  return <DocumentCard document={coverLetter} onOpen={onOpen} onAction={onAction} />;
};
